<template>
  <div class="tender-info-section d-flex flex-wrap gap-2 padding-r-20 padding-l-20 padding-t-20">
    <div class="tender-navigation-block padding-b-20">
      <p class="navigation-element">Անժամկետ Տենդերներ <span>/</span></p>
      <p v-if="tenderData.cpv" class="navigation-element">{{ tenderData.cpv.name }} <span>/</span></p>
      <p class="navigation-last-element" style="">{{ tenderData.name }}</p>
    </div>
    <div class="tender-photo-section col-12 col-md-4 p-0 d-flex flex-col">
      <template v-if="tenderData.pictures && tenderData.pictures.length > 1">
        <div class="col tender-main-photo p-0">
          <img :key="mainPicture" class="w-100 h-100" :src="`${backendUrl}/uploads/${mainPicture}`">
        </div>
        <div class="col tender-secondary-photos p-0 d-flex padding-t-10">
          <img
              @click="() => selectPicture(picture)"
              :key="index"
              v-for="(picture, index) in tenderData.pictures"
              :style="{ width: `calc((100% - ${(tenderData.pictures.length - 1) * 10}px) / ${tenderData.pictures.length})` }"
              class="tender-secondary-photo"
              :class="mainPicture === picture ? 'active-photo' : ''"
              :src="`${backendUrl}/uploads/${picture}`">
        </div>
      </template>
      <template v-else>
        <div class="col tender-main-photo p-0">
          <img :key="mainPicture" class="w-100 h-100" :src="`${backendUrl}/uploads/${mainPicture}`">
        </div>
      </template>
    </div>
    <div class="tender-info col-12 col-md-8 p-0 padding-l-20">
      <div class="tender-info-block d-flex">
        <div class="form-group col-12 col-lg-6 tender-input-group tender-input-group-left padding-r-10">
          <p class="text-weight-d tender-name-text">{{ tenderData.name }}</p>
          <div class="form-group d-flex align-items-center tender-input-group m-0 mt-2">
            <p class="text-secondary">Շուկայական գին`</p>
            <p class="text-weight-d ml-2 tender-price-text">{{ tenderData.market_price }} դր</p>
          </div>
          <div class="form-group d-flex  tender-input-group m-0 mt-1">
            <p class="text-secondary">Մրցույթի ծածկագիր`</p>
            <p class="text-weight-d ml-2">{{ tenderData.code }}</p>
          </div>
          <div class="form-group d-flex  tender-input-group m-0 mt-1">
            <p class="text-secondary">Կատեգորիա`</p>
            <p class="text-weight-d ml-2">{{ selectedCategory?.name}}</p>
          </div>
          <div class="form-group d-flex  tender-input-group m-0 mt-1 mb-2">
            <p class="text-secondary">Չափման միավոր`</p>
            <p class="text-weight-d ml-2">{{ tenderData.unit }}</p>
          </div>
          <div class="form-group d-flex  flex-col tender-input-group m-0">
            <p class="text-secondary">Տեխնիկական բնութագիրը</p>
            <p class="text-weight-d">{{ tenderData.specification }}</p>
          </div>
        </div>
        <div class="form-group col-12 col-lg-6 p-0 flex-col d-flex padding-l-10">
          <div class="form-group d-flex flex-col tender-input-group m-0">
            <p class="text-secondary">Վճարման պայմաններ</p>
            <p class="text-weight-d">{{ tenderData.payment_terms }}</p>
          </div>
          <div class="form-group d-flex flex-col tender-input-group m-0 mt-2">
            <p class="text-secondary">Գնման պայմաններ</p>
            <p class="text-weight-d">{{ tenderData.terms_of_purchase }}</p>
          </div>
          <div class="form-group d-flex flex-col tender-input-group m-0 mt-2">
            <p class="text-secondary">Մատակարարման պայմաններ</p>
            <p class="text-weight-d">{{ tenderData.delivery_terms }}</p>
          </div>
        </div>
      </div>
      <div v-if="!withoutActions" class="tender-button-block row w-100 p-0 m-0">
        <div class="tender-button-group padding-r-10">
          <button @click="() => addToFavorite('buyer')" style="height: 100%;" class="mr-3 btn btn-light հ-100">
            <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.1533 13.1604L20.1533 10.8396H13.1603V3.84671H10.8395V10.8396H3.84668V13.1604H10.8395V20.1533H13.1603L13.1603 13.1604H20.1533Z" fill="#006BE6"/>
            </svg>
            <span>Ավելացնել գնումներում</span>
          </button>
          <button @click="$router.push(`/timeless-tenders/buy/tender/${tender.id}`)" style="height: 100%;" class="btn btn-primary հ-100">
            <span>Գնել</span>
          </button>
        </div>
        <div class="tender-button-group padding-l-10 justify-content-end">
          <button @click="() => addToFavorite('seller')" style="height: 100%;" class="mr-3 btn btn-light հ-100">
            <svg class="mr-2"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.1533 13.1604L20.1533 10.8396H13.1603V3.84671H10.8395V10.8396H3.84668V13.1604H10.8395V20.1533H13.1603L13.1603 13.1604H20.1533Z" fill="#006BE6"/>
            </svg>
            <span>Ավելացնել վաճառքներում</span>
          </button>
          <button @click="$router.push(`/timeless-tenders/sell/tender/${tender.id}`)" style="height: 100%;" class="btn btn-primary հ-100">
            <span>Վաճառել</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import isMobile from '@/mixins/isMobileView'

export default {
  components: {  },
  props: ['tender', 'withoutActions'],
  mixins: [isMobile],
  data() {
    return {
      dateNow: new Date(),
      backendUrl: process.env.VUE_APP_URL,
      tenderData: {},
      mainPicture: '',
      columns: [
        'password',
        'title',
        'products',
        'opening_finish_date',
        'price',
        'region',
        'type',
        'invitation',
        'edit',
        'participants_count'
      ],
    }
  },
  computed: {
    selectedCategory() {
      const base = this.$store.getters['settings/timelessTendersCategories'];
      return base.find(item => item.value === this.tenderData.category);
    },
  },
  mounted() {
    this.tenderData = this.tender;
    if(this.tender?.pictures?.length){
      this.mainPicture = this.tender.pictures[0];
    }
  },
  methods: {
    selectPicture(picture){
      this.mainPicture = picture;
    },
    addToFavorite(type){
      const data = {
        timeless_tender_id: this.tenderData.id,
        type: type
      }
      console.log(type);
      this.$client.post(`timeless-tenders/addFavorite`, data).then(({ data }) => {
        console.log('data', data.data)
        this.tender.is_favorite = true;
        this.getTenders();
      })
      if(type === 'buyer'){
        this.$router.push(`/timeless-tenders/buy/list`)
      } else if(type === 'seller'){
        this.$router.push(`/timeless-tenders/sell/list`)
      }
    }
  },
}
</script>
<style scoped>
.tender-name-text, .tender-price-text{
  font-size: 16px;
  font-weight: 600;
}
.flex-col{
  flex-direction: column !important;
}
.tender-photo-section{
  width: 500px;
  height: 400px;
  .tender-main-photo{
    width: 100%;
    img{
      border-radius: 8px;
      height: 310px !important;
    }
  }
  .tender-secondary-photos{
    height: 80px;
    width: 100%;
    cursor: pointer;
    display: inline-flex;
    gap: 10px;
    .tender-secondary-photo{
      height: 80px !important;
      border-radius: 8px;
    }
    .tender-secondary-photo.active-photo{
      border: 3px solid #0065D9;
    }
  }
}
.tender-info-block{
  min-height: 400px;
  height: fit-content;
  .text-secondary{
    font-size: 13px !important;
  }
}
.tender-info-section{
  height: auto;
  .tender-navigation-block{
    width: 100%;
    display: ruby;
    height: fit-content;

    .navigation-element{
      font-size: 13px;
      line-height: 18px;
      color: #40444D;
      margin: 0 4px;
      white-space: nowrap;
      span{
        margin: 0 0 0 4px;
      }
    }
    .navigation-last-element{
      font-size: 13px;
      line-height: 18px;
      margin: 0 4px;
      color: #6E7485;
    }
  }
  .tender-button-group{
    display: flex;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 1185px) {
  .tender-button-group{
    flex-direction: column;
    button{
      margin: 0 0 8px !important;
    }
  }
}
@media (max-width: 992px) {
  .tender-info-block{
    flex-direction: column !important;
    .form-group{
      padding: 0 !important;
    }
  }
}
@media (max-width: 768px) {
  .tender-info{
    padding: 16px 0 0 0 !important;
  }
}
@media (max-width: 530px) {
  .tender-button-block{
    flex-direction: column;
    .tender-button-group{
      padding: 0 !important;
      width: 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}

</style>

